var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / UY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-UY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,18.6666667 L28,20 L0,20 L0,18.6666667 L28,18.6666667 Z M28,13.3333333 L28,16 L0,16 L0,13.3333333 L28,13.3333333 Z M13.3333333,8 L28,8 L28,10.6666667 L13.3333333,10.6666667 L13.3333333,8 Z M13.3333333,2.66666667 L28,2.66666667 L28,5.33333333 L13.3333333,5.33333333 L13.3333333,2.66666667 Z",
    id: "Combined-Shape",
    fill: "#0E4DC5",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5567504,2.85052864 L7.78220851,4.43379379 L9.16062587,3.62291436 L8.6768036,5.14720958 L10.2705421,5.01470534 L9.17326643,6.17812525 L10.6666667,6.75024029 L9.17326643,7.32235533 L10.2705421,8.48577525 L8.6768036,8.35327101 L9.16062587,9.87756622 L7.78220851,9.06668679 L7.5567504,10.6499519 L6.66666667,9.32130194 L5.77658293,10.6499519 L5.55112483,9.06668679 L4.17270746,9.87756622 L4.65652973,8.35327101 L3.0627912,8.48577525 L4.16006691,7.32235533 L2.66666667,6.75024029 L4.16006691,6.17812525 L3.0627912,5.01470534 L4.65652973,5.14720958 L4.17270746,3.62291436 L5.55112483,4.43379379 L5.77658293,2.85052864 L6.66666667,4.17917865 L7.5567504,2.85052864 Z M6.66666667,4.20478575 C5.26085094,4.20478575 4.12121212,5.34442457 4.12121212,6.75024029 C4.12121212,8.15605602 5.26085094,9.29569484 6.66666667,9.29569484 C8.07248239,9.29569484 9.21212121,8.15605602 9.21212121,6.75024029 C9.21212121,5.34442457 8.07248239,4.20478575 6.66666667,4.20478575 Z M6.66666667,4.66666667 C7.77123617,4.66666667 8.66666667,5.56209717 8.66666667,6.66666667 C8.66666667,7.77123617 7.77123617,8.66666667 6.66666667,8.66666667 C5.56209717,8.66666667 4.66666667,7.77123617 4.66666667,6.66666667 C4.66666667,5.56209717 5.56209717,4.66666667 6.66666667,4.66666667 Z",
    id: "Star-28",
    fill: "#FED443",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/UY.4bbdbbebad35ea7146c02581f4e7b1bb.svg";
export { ForwardRef as ReactComponent };